/* -------------------------------------------------------------------------- */
/*                         Schema Imported Jobs                          */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const importedJob = new schema.Entity('importedJobs', {}, { idAttribute: 'id' });
export const importedJobs = new schema.Array(importedJob);
